import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Icon, Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import StreamForm from "../../../components/data_products/streams/StreamForm";
import {useAdminBucket} from "../../../components/utils";
import {useDeleteDataVendorStreamMutation, useGetDataVendorStreamQuery, useUpdateDataVendorStreamMutation} from '../../../api/dataVendorStreamApiSlice';
import {useControlledTabs} from "../../../components/Tabs";
import useDeleteConfirmation from '../../../components/useDeleteConfirmation';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useGetCurrentUserQuery } from '../../../api/userApiSlice';

const StreamDeleteButton = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, streamId } = useParams();
  const {DeleteConfirmation, deleteConfirmationProps, confirm} = useDeleteConfirmation()
  const [deleteStream] = useDeleteDataVendorStreamMutation()
  const goToIndex = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`
  })
  const onDeleteStream = ()=> {
    deleteStream([dataVendorKey, streamId]).then(()=>(goToIndex()))
  }
  const {data: {isAdmin: userIsAdmin} = {}, isSuccess} = useGetCurrentUserQuery()

  if (userIsAdmin) {
    return (
      <>
        <Button variant='primary' onClick={() => confirm("delete", () => {
          onDeleteStream()
        })}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
        <DeleteConfirmation
          placeholder={t("awsCredentials.deletePlaceholder")}
          {...deleteConfirmationProps}
          confirmValue={t("delete")}
        />
      </>
    )
  }
  return ( <></> );
}

const useStreamChangeValidation = ({onSubmit}) => {
  const { t } = useTranslation();
  const [showStreamChangeAlert, setShowStreamChangeAlert] = useState(false)
  const [data, setData] = useState()
  const validate = (_data, stream) => {
    setData(_data)
    if ( stream.stream != _data.stream ) {
      setShowStreamChangeAlert(true)
    } else {
      onSubmit(_data)
    }
  }
  const AlertDialog = () => (<SweetAlert
    warning
    showCancel
    confirmBtnText={t('save')}
    confirmBtnBsStyle="danger"
    title="Stream destination changed"
    show={showStreamChangeAlert}
    onConfirm={()=>onSubmit(data)}
    onCancel={()=>{setShowStreamChangeAlert(false)}}
    focusCancelBtn
  >
    This will change the file path in the bucket. Existing file will not be move!
  </SweetAlert>)

  return {
    AlertDialog,
    validate
  }
}

export default function EditDataVendorStream(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, streamId } = useParams();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps,] = useControlledTabs("stream", props)
  const bucket = useAdminBucket(dataVendorKey)
  const { data: stream = {}, isSuccess } = useGetDataVendorStreamQuery([dataVendorKey, streamId])

  const goToStream = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}/streams/${streamId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateStream] = useUpdateDataVendorStreamMutation()

  const submitStream = (data)=> {
    updateStream({...data, key: streamId, dataVendorId: dataVendorKey}).unwrap()
        .then(goToStream)
        .catch(error => {})
  }

  const { AlertDialog, validate } = useStreamChangeValidation({onSubmit: submitStream})

  const submitProps = {
    handleSubmit: (data) => {
      validate(data, stream)
    },
    errors: {}
  }

  if ( !isSuccess ) return (<></>)
  return (
    <>
      <Title
        main={t("menu.streams")}
        sub={stream.name}
        group={false}
        onBack={goToStream}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToStream} />
        <StreamDeleteButton/>
      </Title>
      <StreamForm
        bucket={bucket}
        stream={stream}
        unbindBucket={true}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        tabProps={tabProps}
        disabled={(propName)=>{return propName === "data_type"}}
      />
      <AlertDialog />
    </>
  )
}

